import React from 'react';

const FindLoveConfidence = () => {
  return (
    <button 
      className="fixed bottom-20 md:bottom-8 right-4 sm:right-6 z-50 p-3 sm:p-3.5 bg-gradient-to-r from-[#8a216b] to-[#f03f16] text-white rounded-full shadow-2xl hover:scale-110 active:scale-95 transition-all flex items-center justify-center cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
    >
      <svg className="w-5 h-5 sm:w-6 sm:h-6 stroke-current fill-none" viewBox="0 0 24 24">
        <path d="M12 19V5M5 12l7-7 7 7" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
};

export default FindLoveConfidence;